import { TSC_SUGGESTIONS } from "../data/tscPlaybook";
import { TscCustomer, formatTscCustomerId } from "../data/tscCustomers";

// The "Say next" line under the live transcript: what the caller could answer, read off
// what Riley just said. Only the answers a caller needs (verification, reason, which
// order, yes/no); it never steers the call towards a scripted outcome.

function spelled(email: string): string {
  return email.replace(/\./g, " dot ").replace("@", " at ");
}

export function tscLiveHint(c: TscCustomer, lastAgentText: string, callerTurns: number): string | null {
  const s = TSC_SUGGESTIONS[c.id];
  const opener = s?.tryLines[0] ?? "Hi, I'd like to cancel an order.";
  const t = lastAgentText.toLowerCase();
  if (!t) return callerTurns === 0 ? opener : null;
  if (/(is that|did i get that|have i got that|that) (right|correct)|confirm/.test(t)) return "Yes.";
  if (/customer id|customer number/.test(t)) return formatTscCustomerId(c.id);
  if (/zip/.test(t)) return c.zip.split("").join(" ");
  if (/e-?mail/.test(t) && /(what|may i|can i|could i|have|share|provide|get)/.test(t)) return spelled(c.email);
  if (/which (one|order)/.test(t) && s?.whichOrder) return s.whichOrder;
  if (/\bwhy\b|reason/.test(t) && s?.reason) return s.reason;
  if (/into that inbox|access to that (email|inbox)|get into/.test(t)) return "Yes, I can.";
  if (/phone call or (by )?e-?mail|call or e-?mail/.test(t)) return "A phone call, please.";
  // Neighbor's Club is only mentioned after a reset; the caller asks for a teammate to see the warm transfer.
  if (/not a neighbor.s club member/.test(t)) return "Can you connect me with someone to help me sign up?";
  if (/neighbor.s club reward/.test(t)) return "Can you connect me with someone to help me use it?";
  if (/teammate (who )?can help you|connect you\?/.test(t)) return "Yes, please.";
  if (/go ahead|shall i|should i|want me to/.test(t)) return "Yes, please.";
  if (/suggest|recommend/.test(t)) return "Sure.";
  if (/ship(ped)? to you|collect|pick (it )?up/.test(t)) return "Ship it to me.";
  if (/anything else/.test(t)) return "No, that's all.";
  return callerTurns === 0 ? opener : null;
}
